<template>
  <div>
    	<div id="wrapper">
        <img src="../assets/my/2025.png" style="height:120px;"/>

    		<div id="content" style="height:690px;">
    			<p >
    				<strong>
    				    About IDASB
    				</strong>
    			</p>
    			<p>
    			    IDASB (workshop on Integrative Data Analysis in Systems Biology) is a series of workshops that aim at providing a forum for discussion on such integrated data analysis approaches in systems biology as data representation and visualisation, pattern recognition, machine learning, and meta-analysis.
          </p>

          <p>
            This workshop will feature the theme of "integrated approach" and "complex biological system."
          </p>

    			<p>
                    <b>Passed IDASB Workshop Websites</b>
    			</p>
                <table width="100%" border="0" cellspacing="4" cellpadding="0">
                    <tr >
                        <td width="5%">&nbsp;</td>
                        <td width="20%"><span class="my-c"><a href="http://rosalind.infj.ulst.ac.uk/idasb/idasb.html"> IDASB&nbsp;2010</a></span></td>
                        <td width="75%"><span class="my-c">Hong&nbsp;Kong,&nbsp;China</span></td>
                    </tr>
                    <tr>
                        <td width="5%">&nbsp;</td>
                        <td width="20%"><span class="my-c"><a href="http://bioinfo.mc.vanderbilt.edu/idasb/">IDASB&nbsp;2011</a></span></td>
                        <td width="75%"><span class="my-c">Atlanta,&nbsp;USA</span></td>
                    </tr>
                    <tr>
                        <td width="5%">&nbsp;</td>
                        <td width="20%"><span class="my-c"><a href="http://bioinfo.au.tsinghua.edu.cn/idasb2012/">IDASB&nbsp;2012</a></span></td>
                        <td width="75%"><span class="my-c">Philadelphia,&nbsp;USA</span></td>
                    </tr>
                    <tr>
                        <td width="5%">&nbsp;</td>
                        <td width="20%"><span class="my-c"><a href="https://scm.ulster.ac.uk/~e10157676/idasb/">IDASB&nbsp;2013</a></span></td>
                        <td width="75%"><span class="my-c">Shanghai,&nbsp;China</span></td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td><a href="http://bioinfo.mc.vanderbilt.edu/idasb2014/index.html" class="my-c">IDASB&nbsp;2014</a></td>
                      <td> <span class="my-c"> Belfast,&nbsp;UK</span>  </td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td><a href="bioinfo.au.tsinghua.edu.cn/idasb2015/" class="my-c">IDASB&nbsp;2015</a></td>
                      <td> <span class="my-c">DC,&nbsp;USA</span> </td>
                    </tr>
    				<tr>
                      <td>&nbsp;</td>
                      <td><a href="http://scm.ulster.ac.uk/~e10157676/IDASB2016/index.html" class="my-c">IDASB&nbsp;2016</a></td>
                      <td>   <span class="my-c">Shenzhen,&nbsp;China</span> </td>
                    </tr>
    				<tr>
                      <td>&nbsp;</td>
                      <td><a href="http://zhaobioinfo.org/IDASB2017/" class="my-c"> IDASB&nbsp;2017</a></td>
                      <td> <span class="my-c">Kansas City,&nbsp;USA</span>  </td>
                    </tr>
    				<tr>
                      <td>&nbsp;</td>
                      <td><a href="http://scm.ulster.ac.uk/~e10157676/IDASB2018/index.html" class="my-c">IDASB&nbsp;2018</a></td>
                      <td>  <span class="my-c">Madrid,&nbsp;Spain</span> </td>
                    </tr>
                    				<tr>
                      <td>&nbsp;</td>
                      <td><a href="http://zhaobioinfo.org/IDASB2019/index.html" class="my-c">IDASB&nbsp;2019</a></td>
                      <td> <span class="my-c">San&nbsp;Diego,&nbsp;USA</span>  </td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                        <td><a href="http://scm.ulster.ac.uk/~e10157676/IDASB2020/index.html" class="my-c">IDASB&nbsp;2020</a></td>
                        <td><span class="my-c">Virtal&nbsp;(online)</span>  </td>
                    </tr>
                  <tr>
                        <td>&nbsp;</td>
                        <td><a href="https://computing.ulster.ac.uk/~e10157676/IDASB2021/" class="my-c">IDASB&nbsp;2021</a></td>
                        <td>  <span class="my-c">Virtal&nbsp;(online)</span> </td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                        <td><a href="https://computing.ulster.ac.uk/ZhengLab/IDASB2022/index.html" class="my-c">IDASB 2022</a></td>
                        <td><span class="my-c">Virtal&nbsp;(online)</span></td>
                    </tr>

                    <tr>
                        <td>&nbsp;</td>
                        <td><a href="http://www.combio-lezhang.online/IDASB2023/index.html" class="my-c">IDASB 2023</a></td>
                        <td><span class="my-c"> Istanbul, Turkey</span></td>
                    </tr>

                    <tr>
                        <td>&nbsp;</td>
                        <td><a href="http://www.combio-lezhang.online/IDASB2024/index.html" class="my-c">IDASB 2024</a></td>
                        <td><span class="my-c"> Lisbon, Portugal</span></td>
                    </tr>


                </table>
    			<p>
                    <b>Workshop&nbsp;steering&nbsp;committee</b>
    			</p>
            <table width="100%" border="0" cellspacing="4" cellpadding="0">
                            <tr>
                                <td width="5%">&nbsp;</td>
                                <td width="20%"><span class="body_text"><a href="mailto: h.zheng@ulster.ac.uk">Huiru (Jane) Zheng</a></span></td>
                                <td width="75%"><span class="body_text">Ulster University, UK</span></td>
                            </tr>
            				<tr>
                                <td width="5%">&nbsp;</td>
                                <td width="20%"><span class="body_text"><a href="mailto: xiaoming@scu.edu.cn">Ming Xiao</a></span></td>
                                <td width="75%"><span class="body_text">Sichuan University, China</span></td>
                            </tr>
                            <tr>
                                <td width="5%">&nbsp;</td>
                                <td width="20%"><span class="body_text"><a href="mailto: Zhongming.Zhao@uth.tmc.edu">Zhongming Zhao</a></span></td>
                                <td width="75%"><span class="body_text">The University of Texas Health Science Center at Houston, USA</span></td>
                            </tr>
                        </table>
                <footer-component></footer-component>
            </div>
    	</div>
  </div>
</template>

<script>
  import FooterComponent from '@/components/Foot/footer.vue'

  export default {
    components: {
      FooterComponent
    }
  }
</script>

<style>
  p {
    /*或者使用 shorthand 属性*/
    /*padding: 上 右 下 左*/
    /*margin: 上 右 下 左*/
    padding: 10px 20px 10px 20px;
    margin: 10px 20px 10px 20px;
    color: black;
    font-weight: bold;
    text-align: justify;
    text-justify: inter-ideograph;
  }
</style>
